document.addEventListener("DOMContentLoaded", function () {
  let selectedValues = [];
  const targetNodeFilter = document.querySelector("#ProductGridContainer");
  if (targetNodeFilter) {
    const observerOptionsFilter = {
      childList: true,
      subtree: true,
    };
    const observerFilter = new MutationObserver((mutationsList) => {
      for (const mutation1 of mutationsList) {
        if (mutation1.type === "childList") {
          const checkboxes = document.querySelectorAll(
            '#ProductGridContainer input[name="filter.v.option.size"]'
          );
          checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", function () {
              const value = this.value;
              if (this.checked) {
                if (!selectedValues.includes(value)) {
                  selectedValues.push(value);
                }
              } else {
                selectedValues = selectedValues.filter((v) => v !== value);
              }
              const lastSelected =
                selectedValues[selectedValues.length - 1] || null;
              localStorage.setItem("last_selected_variation", lastSelected);
            });
          });
        }
      }
    });
    observerFilter.observe(targetNodeFilter, observerOptionsFilter);
  }
});
